/**
 * Don't change the order of these keys, that will break all URLs with
 * encoded loaded state. Appending new keys is fine.
 */
export const defaultKeys = [
  'between',
  'checked',
  'contains_phrase',
  'contains_substring',
  'contains',
  'equal',
  'greater_or_equal',
  'greater',
  'is_empty',
  'is_not_empty',
  'less_or_equal',
  'less',
  'not_contains_phrase',
  'not_contains_substring',
  'not_contains',
  'not_equal',
  'number',
  'select',
  'string',
  'text',
  'type',
  'unchecked',
  'undefined',
  'AND',
  'OR',
  'checkbox',
  'boolean',
  'true',
  'false',
  'date',
  'null',
  'child-count',
  'component-key',
  'created-by',
  'created',
  'description',
  'displayText',
  'from',
  'last-modified',
  'last-updated',
  'name',
  'parent',
  'rootWorkspace',
  'source',
  'target',
  'to',
  'typeName',
  'UNSET',
];
